import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraButton } from '../ensigns/button';
import { SpecraText } from '../ensigns/typography';
/** Compact previous/next pagination used below operational data sets. */ export const SpecraPagination = /*#__PURE__*/ React.forwardRef(({ className, getNextLabel = (nextPage, label)=>`Next ${label}, page ${nextPage}`, getPreviousLabel = (previousPage, label)=>`Previous ${label}, page ${previousPage}`, itemLabel = 'page', navigationLabel, nextButtonProps, nextText = 'Next →', onPageChange, page, pageCount, previousButtonProps, previousText = '← Previous', statusText = (currentPage, count)=>`${currentPage} of ${count}`, ...props }, ref)=>{
    const safeCount = Math.max(1, pageCount);
    const safePage = Math.min(safeCount, Math.max(1, page));
    return /*#__PURE__*/ _jsxs("nav", {
        ...props,
        "aria-label": navigationLabel ?? (itemLabel === 'page' ? 'Pagination' : `${itemLabel} pagination`),
        className: cn('flex items-center justify-between gap-3', className),
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                "aria-live": "polite",
                size: "caption",
                tone: "muted",
                children: statusText(safePage, safeCount)
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        ...previousButtonProps,
                        "aria-label": previousButtonProps?.['aria-label'] ?? getPreviousLabel(Math.max(1, safePage - 1), itemLabel),
                        disabled: safePage <= 1 || previousButtonProps?.disabled,
                        onClick: (event)=>{
                            previousButtonProps?.onClick?.(event);
                            if (!event.defaultPrevented) onPageChange(safePage - 1);
                        },
                        size: "sm",
                        variant: "secondary",
                        children: previousText
                    }),
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        ...nextButtonProps,
                        "aria-label": nextButtonProps?.['aria-label'] ?? getNextLabel(Math.min(safeCount, safePage + 1), itemLabel),
                        disabled: safePage >= safeCount || nextButtonProps?.disabled,
                        onClick: (event)=>{
                            nextButtonProps?.onClick?.(event);
                            if (!event.defaultPrevented) onPageChange(safePage + 1);
                        },
                        size: "sm",
                        variant: "secondary",
                        children: nextText
                    })
                ]
            })
        ]
    });
});
SpecraPagination.displayName = 'SpecraPagination';
